module.exports = __webpack_public_path__ + "1e2a6898406fe0c18226c486098adb43.MP3";